<template>
  <div v-if="consumptionData && consumptionData.results" class="card my-2">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md-6">
          <b>Daily Consumption</b>
        </div>
        <div class="col-md-6 text-right">
          <strong
            >{{ Math.round(accountData.average) }}
            {{ common.handlePaymentModelName(accountData.payment_model) }} /
            Day</strong
          >
          <div class="text-muted">Average consumption per customer</div>
        </div>
      </div>
    </div>
    <div class="card-body" style="text-align: center">
       <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary" />
      <apex-chart
        v-if="series && series.length && !loading"
        :options="options"
        :series="series"
        :height="400"
      />
    </div>
  </div>
</template>

<script>
import insights from '@/utils/analytics/insights'
import apexChart from 'vue-apexcharts'
import common from '@/utils/analytics/common'
export default {
  name: 'DailyConsumptionLinear',
  components: {
    apexChart
  },
  props: {
    from: {
      type: String,
      default: null
    },
    to: {
      type: String,
      default: null
    },
    accountData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      common,
      consumptionData: {},
      series: [],
      loading: true,
    }
  },
  mounted() {
    this.getConsumptionData()
  },
  watch: {
    from() {
      this.getConsumptionData()
    },
    to() {
      this.getConsumptionData()
    }
  },
  computed: {
    options() {
      return {
        loading: false,
        chart: {
          id: 'session-date',
          height: 300
        },
        markers: {
          size: 1,
          colors: undefined,
          strokeColors: '#fff',
          strokeWidth: 2,
          strokeOpacity: 0.9,
          strokeDashArray: 0,
          fillOpacity: 1,
          discrete: [],
          shape: 'circle',
          radius: 2,
          offsetX: 0,
          offsetY: 0,
          onClick: undefined,
          onDblClick: undefined,
          hover: {
            size: undefined,
            sizeOffset: 3
          }
        },
        stroke: {
          width: [4, 4, 4]
        },
        xaxis: {
          type: 'datetime',
          title: {
            text: ' '
          }
        },
        yaxis: {
          title: {
            text: `${
              this.accountData && this.accountData.payment_model
                ? common.handlePaymentModelName(this.accountData.payment_model)
                : 'Payment Model'
            } / Day`
          },
          labels: {
            formatter(value) {
              return common.numberWithCommas(value)
            }
          }
        }
      }
    }
  },
  methods: {
    getConsumptionData() {
      this.loading = true
      let data = insights.consumptionPerDay({
        params: {
          from: this.from,
          to: this.to
        }
      })
      data
        .then((data) => {
          this.consumptionData = data
          setTimeout(()=>{
            this.drawConsumptionGraph()
          }, 500)
        })
        .catch(() => {
          this.loading = false
        })
    },
    drawConsumptionGraph() {
      let data = []
      if (!this.consumptionData.results) {
        this.loading = false
        return
      }

      this.series = []
      setTimeout(() => {
        this.series.push({
          data: this.consumptionData.results.map(i => ({ x: i.created_at, y: i.count })),
          type: 'line'
        })
        this.loading = false
      }, 500)
    }
  }
}
</script>

<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
